import { formatScore } from './utils.js'

const ROWS = [
  ['Interest', 'interest'],
  ['Novelty', 'novelty'],
  ['Prediction', 'predicted_interest'],
  ['Surprise', 'surprise'],
  ['Curiosity', 'curiosity'],
  ['Uncertainty', 'ensemble_uncertainty'],
]

export default function Measurements({ dream, onOpenDetail }) {
  return (
    <div className="mobi-measurements">
      <div className="mobi-panel-head">
        <span className="dm-section">SIGNALS</span>
        <button
          type="button"
          className="mobi-link"
          onClick={() => onOpenDetail?.({ kind: 'signals', dream })}
        >
          detail
        </button>
      </div>
      <div className="mobi-signal-grid">
        {ROWS.map(([label, key]) => (
          <div key={key} className="mobi-signal">
            <span className="mobi-signal-label">{label}</span>
            <span className="mobi-signal-value">{formatScore(dream?.[key])}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
